/* global elementorFrontend, Swiper */
import $ from 'jquery';

export const sliderCreative = () => {
	const el = {
		parent: '.mi-slider',
	};

	if (!$(el.parent).length) return;

	$(window).on('elementor/frontend/init', function () {
		elementorFrontend.hooks.addAction(
			'frontend/element_ready/image-carousel.default',
			function ($element) {
				// Only target carousels with the defined class
				if (!$element.hasClass(el.parent.replace('.', ''))) {
					return;
				}

				var $swiperContainer = $element.find(
					'.swiper, .swiper-container',
				);
				if (!$swiperContainer.length) {
					return;
				}

				var overrideSwiper = function () {
					var swiper = $swiperContainer[0].swiper;
					if (!swiper) {
						// Swiper might not be initialized yet, retry in 50ms
						setTimeout(overrideSwiper, 50);
						return;
					}

					var params = swiper.originalParams || swiper.params;

					// Prevent infinite loop if already applied
					if (params.effect === 'creative') {
						return;
					}

					// Destroy existing swiper without destroying the DOM elements
					swiper.destroy(false, true);

					// Prepare new parameters with creative effect
					var newParams = Object.assign({}, params, {
						effect: 'creative',
						creativeEffect: {
							prev: {
								shadow: false,
								translate: [0, 0, 0], // Stays in place
								opacity: 0, // Fades out
							},
							next: {
								shadow: false,
								translate: ['100%', 0, 0], // Slides in from right
								opacity: 1, // At full opacity
							},
						},
					});

					// Ensure the swiper wrapper doesn't have transition styles leftover from fade/slide
					$swiperContainer.find('.swiper-wrapper').css({
						'transition-duration': '',
						transform: '',
					});
					$swiperContainer.find('.swiper-slide').css({
						'transition-duration': '',
						transform: '',
						opacity: '',
					});

					// Reinitialize Swiper
					if (typeof elementorFrontend.utils.swiper !== 'undefined') {
						// Elementor 3.2+ asynchronous swiper loader
						const asyncSwiper = elementorFrontend.utils.swiper;
						new asyncSwiper($swiperContainer, newParams).then(
							function (newSwiperInstance) {
								$swiperContainer.data(
									'swiper',
									newSwiperInstance,
								);
							},
						);
					} else if (typeof Swiper !== 'undefined') {
						// Fallback for older Elementor versions where Swiper is global
						var newSwiper = new Swiper(
							$swiperContainer[0],
							newParams,
						);
						$swiperContainer.data('swiper', newSwiper);
					}
				};

				overrideSwiper();
			},
		);
	});
};

try {
	sliderCreative();
} catch (error) {
	console.warn(error);
}
